import { SET_ALL_MY_TASKS } from "../types";
import configVars from "../../config";

export const getTasksFromAPI = (userJwt) => async (dispatch) => {
  try {
    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/get-user-tasks`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: userJwt,
        }),
      }
    );
    const tasksResponse = await response.json();
    dispatch({
      type: SET_ALL_MY_TASKS,
      payload: {
        actionPlans: tasksResponse?.data?.action_plan,
        implementations: tasksResponse?.data?.implementation,
      },
    });
  } catch (error) {}
};
